import React from 'react';
import HarbourIcon from '../../components/harbour/HarbourIcon';

/**
 * The family portal's loading state (TDI-697): "Loading" announced as a
 * status. On a laptop three grey bars sit under it (3475:15336), the same
 * bars as FamilyRecordStates; on a phone a spinner sits above it
 * (3313:130328). The switch is CSS-only, at the family 1100px breakpoint.
 * The bars only pulse for people who have not asked for less motion.
 */
export default function FamilyLoadingState() {
  return (
    <div className="family-loading-state" role="status">
      <span className="family-loading-state__spinner" aria-hidden="true">
        <HarbourIcon name="spinner" size={24} />
      </span>
      <p className="family-loading-state__label">Loading</p>
      <div className="harbour-skeleton-bars family-loading-state__bars motion-safe:animate-pulse" aria-hidden="true">
        <div className="harbour-skeleton" />
        <div className="harbour-skeleton" />
        <div className="harbour-skeleton" />
      </div>
    </div>
  );
}
